<template>
	<button class="spin-btn">
		<Loading v-if="loading" :color="color" class="spin-btn__spinner" />
		<slot v-else />
	</button>
</template>

<script>
import Loading from '@/components/shared/Loading'

export default {
	name: 'SpinnerButton',
	props: {
		loading: Boolean,
		color: {
			type: String,
			default: 'blue'
		}
	},
	components: {
		Loading
	}
}
</script>

<style lang="scss" scoped>
.spin-btn {
	position: relative;

	&__spinner {
		transform: scale(0.5);
	}
}
</style>
